export const API_subscription = (): string => '/api/v2/subscription';
export const API_subscription_type = (subscriptionId: string): string =>
  `/api/v2/subscription/${subscriptionId}/type`;
export const API_subscription_id = (subscriptionId: string): string =>
  `/api/v2/subscription/${subscriptionId}`;
export const API_subscription_bulk = (): string => 'api/v2/subscription/update-all';
